module.exports = __webpack_public_path__ + "static/media/Group 7020.43506feb.svg";